import React from 'react';
import styles from './Button.module.css';

interface ButtonProps {
  variant: 'primary' | 'secondary' | 'outline' | 'outlineNoTheme' | 'text' | 'text-underline';
  onClick?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
                                         variant,
                                         onClick,
                                         children,
                                         disabled = false,
                                         className,
                                         leftIcon,
                                         rightIcon,
                                         fullWidth = false,
                                       }) => {
  const hasIcon = leftIcon || rightIcon;

  return (
      <button
          className={`${
              hasIcon ? styles.withIcon : styles.button
          } ${styles[variant]}  ${disabled ? styles.disabled : ''} ${fullWidth ? styles.fullWidth : ''} ${className || ''}`}
          onClick={onClick}
          disabled={disabled}
      >
        {leftIcon && <div className={styles.icon}>{leftIcon}</div>}
        {children}
        {rightIcon && <div className={styles.icon}>{rightIcon}</div>}
      </button>
  );
};

export default Button;
